module.exports = __webpack_public_path__ + "static/media/LogoWhite.9faccb6e.svg";